import React from "react";
import "./sideNavbar.css";
import { Link, useNavigate } from "react-router-dom";

export default function SideNavbar() {
  const navigate = useNavigate();
  const logOut = () =>{
    sessionStorage.clear();
    // window.location.pathname = '/SignIn'
    navigate("/SignIn");
  }
  const myProject = () =>{
    const RemoveItem = [
      "projects",
      "cid",
      "customerName",
      "projectId",
      "roofPolygons",
      "structureItem",
      "myData",
      "imageSrc",
      "ImageSrc"
    ];
    RemoveItem.forEach((key) => {
      sessionStorage.removeItem(key);
    });
    // window.location.pathname = "/Dashboard"
    navigate("/Dashboard");
  }
  return (
    <div className="sideNavbar">
      <div className="Nav">
        <div className="mainNav">
          <h6>Manage</h6>
            <div className="navItem activeItem1" onClick={myProject}>
              <i className="bi bi-folder-fill"></i>
              <h5>My Projects</h5>
            </div>
          <Link to="/myCustomer">
            <div className="navItem activeItem2">
              <i className="bi bi-people-fill"></i>
              <h5>My Customers</h5>
            </div>
          </Link>
        </div>
        <div className="account">
          <h6>Account</h6>
          <Link to="/settings">
            <div className="navItem activeItem3">
              <i className="bi bi-gear-fill"></i>
              <h5>Settings</h5>
            </div>
          </Link>
          <div className="navItem" onClick={logOut}>
            <i className="bi bi-arrow-right-circle-fill"></i>
            <h5 onClick={logOut}>Logout</h5>
          </div>
        </div>
      </div>
    </div>
  );
}
